import React, { useEffect, useState, createContext } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "./i18n/i18n";
import Nav from "./components/Nav";
import LangWelcome from "./components/LangWelcome";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Infos from "./pages/Infos";
import About from "./pages/About";
import Admin from "./pages/Admin";
import DownloadPage from "./pages/Download";
import Buy from "./pages/Buy";
import InvoicePage from "./pages/Invoice";
import Privacy from "./pages/Privacy";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const SettingsContext = createContext(null);

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
    if (pathname !== "/admin") {
      try {
        import("./lib/track").then((m) => m.track("visit", "", pathname));
      } catch {}
    }
  }, [pathname]);
  return null;
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }
  static getDerivedStateFromError(e) {
    return { err: e };
  }
  render() {
    if (this.state.err)
      return (
        <div className="min-h-screen flex items-center justify-center bg-ink text-cream p-8 text-center font-sans">
          <p>Une erreur est survenue. Rechargez la page.</p>
        </div>
      );
    return this.props.children;
  }
}

function App() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then((r) => setSettings(r.data))
      .catch(() => {});
  }, []);

  return (
    <LangProvider>
      <SettingsContext.Provider value={settings}>
        <BrowserRouter>
          <ScrollToTop />
          <Nav />
          <LangWelcome />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/learn" element={<Infos />} />
            <Route path="/about" element={<About />} />
            <Route path="/nous-achetons" element={<Buy />} />
            <Route path="/telecharger" element={<DownloadPage />} />
            <Route path="/download" element={<DownloadPage />} />
            <Route path="/facture/:id" element={<InvoicePage />} />
          <Route path="/confidentialite" element={<Privacy />} />
          <Route path="/privacy" element={<Privacy />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" />
      </SettingsContext.Provider>
    </LangProvider>
  );
}

export default App;
